import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

export function parseFlexibleDate(dateString, formats = [
    "DD/MM/YY", "DD-MM-YYYY", "YYYY-MM-DD", "MM/DD/YYYY", "YYYY/MM/DD"
]) {
    for (const format of formats) {
        const parsed = dayjs(dateString, format, true); // strict parsing
        if (parsed.isValid()) {
            return parsed.toDate();
        }
    }
    return null;
}

export function appendEmptyStrings(row) {
    const parts = [];
    for (const key in row) {
        if (key.startsWith("__EMPTY")) {
            parts.push(row[key]);
            delete row[key];
        }
    }
    return [row.Description, ...parts].join(", ");
}